import React from 'react';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';

import { Grid, Icon } from '../../components';
import {
    certificadoService,
    Utils,
} from '../../services';
import PrincipalMaster from '../master/Principal';
import PublicMaster from '../master/Public';

class ImprimirCertificadoComissao extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            nome: '',
            dsCertificados: [],
        };
    }

    async onSubmit(event) {
        event.preventDefault();
        await this.buscarCertificados();
    }

    async buscarCertificados() {
        const {
            nome,
        } = this.state;
        try {
            const response = await certificadoService.buscarCertificadosComissao(nome);
            this.setState({ dsCertificados: response.certificados }, () => Utils.showLoading(false));
        } catch (error) {
            Utils.showToast(error.message);
            Utils.showLoading(false);
        }
    }

    render() {
        const {
            nome,
            dsCertificados,
        } = this.state;
        const MasterPage = Utils.getUsuarioEstaLogado() ? PrincipalMaster : PublicMaster;

        return (
            <MasterPage title="Imprimir Certificado Comissão" {...this.props}>
                <div>
                    <div className="padding-content">
                        <form onSubmit={e => this.onSubmit(e)}>
                            <TextField
                                floatingLabelFixed
                                floatingLabelText="Digite o seu NOME COMPLETO ou E-MAIL"
                                fullWidth
                                onChange={e => this.setState({ nome: e.target.value })}
                                value={nome}
                            />
                            <br />
                            <br />
                            <RaisedButton label="Buscar certificados" primary type="submit" />
                            <br />
                            <br />
                            <Grid
                                rowsPerPage={10}
                                showSearch={false}
                                columnSortDefault={0}
                                stripedRows
                                textTableEmpty="Nenhum certificado de comissão encontrado."
                                dataSource={dsCertificados}
                                columns={[
                                    {
                                        text: 'Nome ouvinte',
                                        name: 'NOME',
                                        allowSort: true,
                                    },
                                    {
                                        text: 'Evento',
                                        name: 'NOMEEVENTO',
                                        allowSort: true,
                                    },
                                    {
                                        text: 'Subevento',
                                        name: 'NOMESUBEVENTO',
                                        allowSort: true,
                                    },
                                    {
                                        name: item => (
                                            <div style={{ textAlign: 'center' }}>
                                                <IconButton tooltip="Gerar certificado" containerElement="a" target="_blank" href={item.URL_CERTIFICADO}>
                                                    <Icon name="credit_card" />
                                                </IconButton>
                                            </div>
                                        ),
                                        allowSort: false,
                                    },
                                ]}
                            />
                        </form>
                    </div>
                </div>
            </MasterPage>
        );
    }
}

export default ImprimirCertificadoComissao;
